import React, { useEffect } from 'react';
import { Accordion, AccordionItem } from '@storeblocks/accordion';
import Button from '@storeblocks/button';
import { getCurrentLanguage, getText, } from '@storebrand-digital/fms-translations';
import Markdown from '../../../../components/Markdown';
import { ButtonWrap } from '../styled';
import { useModalContext } from '../../../../components/Context';
import { Description } from './styled';
function Tip(_a) {
    var tip = _a.tip, label = _a.label, trackId = _a.trackId, initialOpen = _a.initialOpen, setShowTip = _a.setShowTip, onBackClick = _a.onBackClick;
    var language = getCurrentLanguage();
    var _b = useModalContext(), setHeading = _b.setHeading, setFooter = _b.setFooter;
    useEffect(function () {
        var _a, _b;
        setHeading(label);
        setFooter(React.createElement(ButtonWrap, null,
            onBackClick !== undefined && (React.createElement(Button, { onClick: onBackClick, variant: "outlined", "data-trackid": "button-".concat(trackId, "_back|").concat((_a = getText('compose.tip.back.label')
                    .split(' ')) === null || _a === void 0 ? void 0 : _a.join('_')) }, getText('compose.tip.back.label'))),
            React.createElement(Button, { onClick: onWriteMessageClick, "data-trackid": "button-".concat(trackId, "_write_message|").concat((_b = getText('compose.tip.write.label')
                    .split(' ')) === null || _b === void 0 ? void 0 : _b.join('_')) }, getText('compose.tip.write.label'))));
    }, [setHeading, setFooter, getText]);
    var onWriteMessageClick = function () {
        setShowTip(false);
    };
    var lang = language === 'nb' ? 'no' : language;
    return (React.createElement(React.Fragment, null,
        React.createElement(Description, null, getText('tip.description')),
        React.createElement(Accordion, { initial: initialOpen, borderBottom: false, icon: "chevron" }, tip.map(function (_a) {
            var _b, _c;
            var title = _a.title, description = _a.description;
            return (React.createElement(AccordionItem, { id: title.no, key: title.no, "data-trackid": "faq-".concat((_c = (_b = title.no) === null || _b === void 0 ? void 0 : _b.split(' ')) === null || _c === void 0 ? void 0 : _c.join('_')), header: title[lang], content: React.createElement(Markdown, { text: description[lang] }) }));
        }))));
}
export default Tip;
